import {
    SET_TOKEN,
    FAILED_GET_TOKEN,
    SET_USER,
    FAILED_GET_USER,
    FAILED_VERIFY_TOKEN,
    RESET_REDIRECT_STATE,
    SET_DME_CLIENTS,
    FAILED_GET_DME_CLIENTS,
    SET_CLIENT_PK,
    SUCCESS_RESET_PASSWORD,
    FAILED_RESET_PASSWORD,
    SUCCESS_RESET_PASSWORD_CONFIRM,
    FAILED_RESET_PASSWORD_CONFIRM,
    LOGOUT,
    RESET_ERROR_MESSAGE,
} from '../constants/authConstants';

const defaultState = {
    token: '',
    successMessage: null,
    errorMessage: null,
    username: '',
    useremail: '',
    clientname: '',
    clientId: null,
    isLoggedIn: false,
    redirect: false,
    dmeClients: [],
    clientPK: null,
    manualBookingUiEnabled: null,
    canZendeskWrite: false,
};

export const AuthReducer = (state = defaultState, {
    type,
    token,
    successMessage,
    errorMessage,
    username,
    useremail,
    clientname,
    clientId,
    isLoggedIn,
    dmeClients,
    clientPK,
    manualBookingUiEnabled,
    canZendeskWrite
}) => {
    switch (type) {
        case LOGOUT:
            return {
                ...state,
                token: null,
                errorMessage: null,
                redirect: false,
                isLoggedIn: false,
                username: null,
                useremail: null,
                clientname: null,
                dmeClients: [],
                clientPK: null,
                manualBookingUiEnabled: null,
                canZendeskWrite: false,
            };
        case SET_TOKEN:
            return {
                ...state,
                token: token,
                isLoggedIn: true,
                redirect : false,
            };
        case FAILED_GET_TOKEN:
        case FAILED_VERIFY_TOKEN:
            return {
                ...state,
                errorMessage: errorMessage,
                redirect : true,
            };
        case SUCCESS_RESET_PASSWORD:
        case SUCCESS_RESET_PASSWORD_CONFIRM:
            return {
                ...state,
                successMessage: successMessage,
                errorMessage: null
            };
        case FAILED_RESET_PASSWORD:
        case FAILED_RESET_PASSWORD_CONFIRM:
            return {
                ...state,
                errorMessage: errorMessage,
                successMessage: null
            };
        case SET_USER:
            return {
                ...state,
                username: username,
                clientname: clientname,
                useremail: useremail,
                clientId: clientId,
                clientPK: clientPK,
                isLoggedIn: isLoggedIn,
                manualBookingUiEnabled: manualBookingUiEnabled,
                redirect : false,
                canZendeskWrite: canZendeskWrite,
            };
        case FAILED_GET_USER:
            return {
                ...state,
                errorMessage: errorMessage,
                isLoggedIn: isLoggedIn,
                redirect : true,
            };
        case RESET_REDIRECT_STATE:
            return {
                ...state,
                redirect: false,
            };
        case SET_DME_CLIENTS:
            return {
                ...state,
                dmeClients: dmeClients,
                redirect : false,
            };
        case FAILED_GET_DME_CLIENTS:
            return {
                ...state,
                errorMessage: errorMessage,
                redirect : false,
            };
        case SET_CLIENT_PK:
            return {
                ...state,
                clientPK: clientPK,
            };
        case RESET_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: null,
            };
        default:
            return state;
        
    }
};



// WEBPACK FOOTER //
// ./src/state/reducers/authReducer.js